'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Device info class
 */
var DeviceInfo = function () {

    /**
     * Constructor
     * @constructor
     */
    function DeviceInfo() {
        (0, _classCallCheck3.default)(this, DeviceInfo);

        this.info = {
            os: 'ios',
            tablet: true,
            native: false,
            version: 0,
            appVersion: null
        };
        this.isPristine = true;
    }

    /**
     * Choose value if condition is true
     * @param {any} condition Any expression
     * @param {Function} valueFunc Function that returns value
     * @param {any} defaultValue Default value
     * @returns {*} New or default value
     */


    (0, _createClass3.default)(DeviceInfo, [{
        key: 'setIfTrue',
        value: function setIfTrue(condition, valueFunc, defaultValue) {
            if (this.isPristine && condition) {
                this.isPristine = false;
            }
            return condition ? valueFunc() : defaultValue;
        }
    }, {
        key: 'setup',
        value: function setup(data) {
            this.info.os = this.setIfTrue(!!data.device_os, function () {
                return data.device_os.toLowerCase();
            }, this.info.os);
            this.info.tablet = this.setIfTrue(typeof data.is_tablet === 'boolean', function () {
                return data.is_tablet;
            }, this.info.tablet);
            this.info.native = this.setIfTrue(typeof data.is_native === 'boolean', function () {
                return data.is_native;
            }, this.info.native);
            this.info.version = this.setIfTrue(typeof data.os_version === 'number', function () {
                return data.os_version;
            }, this.info.version);
            this.info.appVersion = this.setIfTrue(typeof data.app_version === 'string', function () {
                return data.app_version;
            }, this.info.appVersion);
        }

        /**
         * Returns os name
         *
         * @returns {string} os name
         *
         * @public
         */

    }, {
        key: 'toString',


        /**
         * Returns the device params in a stringified form os[-tablet]-native||-web
         * @returns {string} device string
         */
        value: function toString() {
            return this.osName + (this.isTablet ? '-tablet' : '') + (this.isNative ? '-native' : '-web');
        }
    }, {
        key: 'osName',
        get: function get() {
            return this.info.os;
        }

        /**
         * Checks if device is tablet
         *
         * @returns {boolean} is devide tablet
         *
         * @public
         */

    }, {
        key: 'isTablet',
        get: function get() {
            return this.info.tablet === true;
        }

        /**
         * Checks if device is native
         *
         * @returns {boolean} is devide native
         *
         * @public
         */

    }, {
        key: 'isNative',
        get: function get() {
            return this.info.native === true;
        }
        /**
         * Checks if device is desktop
         *
         * @returns {boolean} is device desktop
         *
         * @public
         */

    }, {
        key: 'isDesktop',
        get: function get() {
            return this.info.os === 'desktop';
        }
        /**
         * Checks if device is ios & native
         *
         * @returns {boolean} is devie ios and native
         *
         * @public
         */

    }, {
        key: 'isIosNative',
        get: function get() {
            return this.info.os === 'ios' && this.isNative;
        }
        /**
         * Checks os version
         *
         * @returns {number} os number
         *
         * @public
         */

    }, {
        key: 'osVersion',
        get: function get() {
            return this.info.version;
        }

        /**
         * Checks native app version
         *
         * @returns {null | string} string with app version when valid (context of native app wrapper),
         * null when not valid (web application)
         *
         * @public
         */

    }, {
        key: 'appVersion',
        get: function get() {
            return this.info.appVersion;
        }

        /**
         * Checks if device is ios
         *
         * @returns {boolean} is ios
         *
         */

    }, {
        key: 'isIos',
        get: function get() {
            return this.info.os === 'ios';
        }
        /**
         * Checks if device is android
         *
         * @returns {boolean} is device android
         *
         * @public
         */

    }, {
        key: 'isAndroid',
        get: function get() {
            return this.info.os === 'android';
        }

        /**
         * Checks if is running in mobile web
         *
         * @returns {boolean} is mobile
         *
         * @public
         */

    }, {
        key: 'isMobile',
        get: function get() {
            return !this.isDesktop && !this.isNative && !this.isTablet;
        }
    }]);
    return DeviceInfo;
}();

exports.default = DeviceInfo;
//# sourceMappingURL=DeviceInfo.js.map